import { Fragment } from "react";
import { BreadcrumbText, BreadcrumbLink } from "./styles.breadcrumb";

export default function Breadcrumb({ items }) {
  return (
    <BreadcrumbText>
      {items.map((item, index) => (
        <Fragment key={item.label}>
          {index > 0 && " / "}
          {item.onClick ? (
            <BreadcrumbLink type="button" onClick={item.onClick}>
              {item.label}
            </BreadcrumbLink>
          ) : (
            item.label
          )}
        </Fragment>
      ))}
    </BreadcrumbText>
  );
}

export { BreadcrumbText, BreadcrumbLink };
